import * as ATC from "../lib/ATClient/ATClient.js";
import util from "./util";

function AT_Command(login_uid, login_ext, strCmd, val1, val2, val3) {
    // if (isConnect_CTI < 1) {
    //     alert("请先连接CTI服务器!");
    //     return false;
    // }
    switch (strCmd) {
        case "Pickup": //接听电话
            ATC.ATAnswer(login_uid, "");
            break;
        case "Hangup": //挂断
            ATC.ATHangup(login_uid, "");
            break;
        case "Pickup_dj": //代接
            ATC.ATPickCall(login_uid, val1, "");
            break;
        case "PlaceCall": // 呼叫电话
            if (!login_ext) {
                util.error("请登录坐席后再拨打电话！");
                return false;
            }
            var phone1 = val1.replace(/^9(0){0,1}/, ""); //外呼需加拨9（本地）或90（外地），无法使用普通的校验
            if (!val1 /*||!util.isPhone(phone1)*/) {
                util.error("请输入正确的电话号码！");
                return false;
            }
            var callResponse = ATC.ATPlaceCall(login_uid, val1);
            if (callResponse != "OK") {
                util.error("呼叫中心异常，请联系管理人员！");
            }
            break;
        case "HoldCall": //保持呼叫
            ATC.ATHoldCall(login_uid);
            break;
        case "RetriveCall": //恢复呼叫
            ATC.ATRetriveCall(login_uid, "");
            break;
        case "TransCall": // 单步转接
            ATC.ATTranCall(login_uid, val1);
            break;
        case "ConsTrans": // 协商转接
            ATC.ATConsTrans(login_uid, val1);
            break;
        case "GetBack": // 协商转接、会议会议取回
            ATC.ATGetBack(login_uid);
            break;
        case "DisConnect": // 协商转接、会议会议挂断
            ATC.ATDisConnect(login_uid, val1);
            break;
        case "TranOver": // 协商转接完成
            ATC.ATTranOver(login_uid, "");
            break;
        case "TransIVR": // 转接IVR
            var strIvr =
                "AC_SWITCHIVR;CALLID=;EXT=" +
                login_ext +
                ";IVRFILE=" +
                val1 +
                ";NODE=" +
                val2 +
                ";IVRMSG=自己定义;";
            ATC.ATTranCall_toIVR(login_uid, 0, "", strIvr, strIvr);
            break;
        case "Conf_est": // 单步建立会议
            ATC.ATConf_est(login_ext, val1);
            break;
        case "ConsConf": // 协商会议
            ATC.ATConsConf(login_uid, val1);
            break;
        case "ConfOver": // 协商会议完成
            ATC.ATConfOver(login_uid, "");
            break;

        case "Insert": // 强插
            ATC.ATInsert(login_uid, val1, 1);
            break;
        case "MoniExt": // 监听
            ATC.ATInsert(login_uid, val1, 2);
            break;
        case "DiscCall": //强 拆
            ATC.ATDiscCall(login_uid, val1, "");
            break;

        case "SendNote": //发送公文
            var strSend =
                "SHORTMSG;FROM=" +
                login_uid +
                ";TO=" +
                val1 +
                ";CALLID=12345678;SUB=" +
                val2;
            ATC.ATSendMsg(login_uid, val1, strSend);
            break;
        case "SendEmail": //发送邮件
            var strSend =
                "EMAIL_SEND;GHID=" +
                login_uid +
                ";TO=" +
                val1 +
                ";SUBJ=测试邮件;MSG=" +
                val2;
            ATC.ATSendOEMCommand(login_uid, "", "AGENTTOMCI", strSend);
            break;
        case "SendSms": //发送短信
            var strSend =
                "SMS_SEND;UID=" +
                login_uid +
                ";TEL=" +
                val1 +
                ";SUBJ=测试短信;BODY=" +
                val2;
            ATC.ATSendOEMCommand(login_uid, "", "AGENTTOMCI", strSend);
            break;

        case "SetBusy": //座席置忙
            ATC.ATSetBusy(login_uid, 1, val1);
            break;
        case "SetNoBusy": //取消置忙
            ATC.ATSetBusy(login_uid, 0, val1);
            break;
        case "SetLeave": // 离席
            ATC.ATSetLeaveSeat(login_uid, 1, val1);
            break;
        case "SetNoLeave": // 取消离席
            ATC.ATSetLeaveSeat(login_uid, 0, val1);
            break;
        case "AfterWorking": // 进入事后处理
            ATC.ATSetAfterWorking(login_uid, 1, val1);
            break;
        case "AfterNoWorking": // 取消事后处理
            ATC.ATSetAfterWorking(login_uid, 0, val1);
            break;

        default:
            alert("未处理命令：" + strCmd);
            break;
    }
    return true;
}


export {
    AT_Command
};
